/* Category navigation only. Prices and links are server-rendered by Shopify. */
(() => {
  if(customElements.get('dashea-product-discovery'))return;
  customElements.define('dashea-product-discovery',class extends HTMLElement {
    connectedCallback(){
      if(this.abort)return;
      const filters=this.querySelector('[data-discovery-filters]');
      if(!filters)return;
      this.abort=new AbortController();
      const buttons=[...filters.querySelectorAll('[data-discovery-filter]')];
      const groups=[...this.querySelectorAll('[data-discovery-group]')];
      const select=key=>{
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.discoveryFilter===key)));
        groups.forEach(group=>{group.hidden=group.dataset.discoveryGroup!==key;if(!group.hidden)group.scrollLeft=0;});
      };
      buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.discoveryFilter),{signal:this.abort.signal}));
      select(buttons[0].dataset.discoveryFilter);
      filters.hidden=false;
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;}
  });
})();
